import styled from '@emotion/styled';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

export const Dialog = styled(MuiDialog)`
  .MuiBackdrop-root {
    background-color: rgba(15, 15, 15, 0.5);
  }

  .MuiDialog-scrollPaper {
    align-items: ${({ position }) => {
      if (position === 'top') {
        return 'baseline';
      } else if (position === 'bottom') {
        return 'end';
      } else {
        return 'center';
      }
    }};
  }

  .MuiDialog-paperScrollPaper {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
`;

export const DialogTitle = styled(MuiDialogTitle)`
  padding: 1.08rem;
  border-bottom: 1px solid #e5e5e5;

  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    font-family: ${({ theme }) => theme.fonts.secondary};
  }
`;

export const DialogContent = styled(MuiDialogContent)`
  padding: 1.45rem;
  border-bottom: 1px solid #e5e5e5;

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.textDark};
    font-family: ${({ theme }) => theme.fonts.secondary};
  }
`;

export const DialogActions = styled(MuiDialogActions)`
  padding: 1.35rem;

  .MuiButton-root {
    margin-left: 1.43rem;
  }
`;

export const CloseButton = styled.button`
  font-size: 1.5rem;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.secondary};
  opacity: 0.2;
  color: ${({ theme }) => theme.colors.textDark};
  float: right;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.5;
  }
`;

export const Flag = styled.span`
  background: #f0ad4e;
  padding: 0.15rem 0.45rem 0.23rem;
  color: ${({ theme }) => theme.colors.textLight};
  border-radius: 0.25rem;
  font-size: 75%;
  font-weight: bold;
  margin-right: 0.2rem;
`;
